import _ from "lodash";
import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";

export class EnsenyamentsPreinscripcioCercaService {
  private apiurl = `${this.SharedProperties.baseUrlService()}/MOE/services/estudis/`;

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $q: ng.IQService,
    private $http: ng.IHttpService,
  ) {}

  getFamiliesFromGraus(ensenyament: string, parameters: any): ng.IPromise<any> {
    const params = this.parseCiclesParams(parameters.graus);
    return this.$http
      .get(`${this.apiurl}getFamiliesByGraus?subetapafie=${ensenyament}&${params}`)
      .then((response: any) => {
        return _.sortBy(response.data, "nom");
      })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return this.$q.reject();
      });
  }

  getEstudisFromFamilies(ensenyament: string, parameters: any): ng.IPromise<any> {
    const params = `&${this.parseCiclesParams(parameters.graus)}&${this.parseFamiliesParams(parameters.families)}`;
    return this.$http
      .get(`${this.apiurl}getEstudisByGrausAndFamilies?subetapafie=${ensenyament}${params}`)
      .then((response: any) => {
        return _.sortBy(response.data, "nom");
      })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return this.$q.reject();
      });
  }

  getBatxillerats(): ng.IPromise<any> {
    return this.$http
      .get(`${this.apiurl}getBatxillerats`)
      .then((response: any) => response.data)
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return this.$q.reject();
      });
  }

  async getFormacioProfesionalGraus(): Promise<any> {
    try {
      const response = await this.$http.get(`${this.apiurl}getFormacioProfesionalGraus`);
      return response.data;
    } catch (error) {
      this.NotificationsService.sendMessage("S'ha produit un error", "error");
      return this.$q.reject();
    }
  }

  private parseCiclesParams(cicles: string[]): string {
    return cicles.map((cicle) => `graus=${cicle}`).join("&");
  }

  private parseFamiliesParams(families: string[]): string {
    return families.map((family) => `families=${family}`).join("&");
  }
}

angularJsApp.service(
  AppServicesEnum.ENSENYAMENTS_PREINSCRIPCIO_CERCA_SERVICE,
  EnsenyamentsPreinscripcioCercaService,
);
